// extracted by mini-css-extract-plugin
export default {"selectedObjectList":"SelectedObjects_selectedObjectList__+qdna"};